const NoRepresentative = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="132" height="111" viewBox="0 0 132 111" fill="none">
      <g clipPath="url(#clip0_291_312)">
        <path
          d="M65.9999 110.858C96.2576 110.858 120.786 86.2275 120.786 55.8441C120.786 25.4607 96.2576 0.830078 65.9999 0.830078C35.7422 0.830078 11.2135 25.4607 11.2135 55.8441C11.2135 86.2275 35.7422 110.858 65.9999 110.858Z"
          fill="#B8AEE9"
          fillOpacity="0.13"
        />
        <path
          d="M129.437 15.8809H2.56315C1.32453 15.8809 0.320435 16.885 0.320435 18.1236V48.8808C0.320435 50.1195 1.32453 51.1236 2.56315 51.1236H129.437C130.675 51.1236 131.679 50.1195 131.679 48.8808V18.1236C131.679 16.885 130.675 15.8809 129.437 15.8809Z"
          fill="white"
          stroke="#EBEBEB"
          strokeWidth="0.64078"
        />
        <path
          d="M98.3593 35.4219H38.767C37.5284 35.4219 36.5243 36.426 36.5243 37.6646C36.5243 38.9032 37.5284 39.9073 38.767 39.9073H98.3593C99.5979 39.9073 100.602 38.9032 100.602 37.6646C100.602 36.426 99.5979 35.4219 98.3593 35.4219Z"
          fill="#9B8DDF"
          fillOpacity="0.13"
        />
        <path
          d="M57.9903 27.0918H38.767C37.5284 27.0918 36.5243 28.0959 36.5243 29.3345C36.5243 30.5731 37.5284 31.5772 38.767 31.5772H57.9903C59.2289 31.5772 60.233 30.5731 60.233 29.3345C60.233 28.0959 59.2289 27.0918 57.9903 27.0918Z"
          fill="#C5BDEB"
        />
        <path
          d="M129.437 58.4551H2.56315C1.32453 58.4551 0.320435 59.4592 0.320435 60.6978V91.4551C0.320435 92.6937 1.32453 93.6978 2.56315 93.6978H129.437C130.675 93.6978 131.679 92.6937 131.679 91.4551V60.6978C131.679 59.4592 130.675 58.4551 129.437 58.4551Z"
          fill="white"
          stroke="#EBEBEB"
          strokeWidth="0.64078"
        />
        <path
          d="M77.8545 77.9961H38.7671C37.5285 77.9961 36.5244 79.0002 36.5244 80.2388C36.5244 81.4774 37.5285 82.4815 38.7671 82.4815H77.8545C79.0931 82.4815 80.0972 81.4774 80.0972 80.2388C80.0972 79.0002 79.0931 77.9961 77.8545 77.9961Z"
          fill="#9B8DDF"
          fillOpacity="0.13"
        />
        <path
          d="M63.7574 69.668H38.7671C37.5285 69.668 36.5244 70.6721 36.5244 71.9107C36.5244 73.1493 37.5285 74.1534 38.7671 74.1534H63.7574C64.996 74.1534 66.0001 73.1493 66.0001 71.9107C66.0001 70.6721 64.996 69.668 63.7574 69.668Z"
          fill="#C5BDEB"
        />
        <path
          d="M17.17 26L22 30.83V42H10V26H17.17ZM18 24H10C8.9 24 8 24.9 8 26V42C8 43.1 8.9 44 10 44H22C23.1 44 24 43.1 24 42V30L18 24ZM16 36C17.1 36 18 35.1 18 34C18 32.9 17.1 32 16 32C14.9 32 14 32.9 14 34C14 35.1 14.9 36 16 36ZM20 39.43C20 38.62 19.52 37.9 18.78 37.58C17.93 37.21 16.99 37 16 37C15.01 37 14.07 37.21 13.22 37.58C12.48 37.9 12 38.62 12 39.43V40H20V39.43Z"
          fill="#707070"
        />
        <path
          d="M17.8496 68L22.6796 72.83V84H10.6796V68H17.8496ZM18.6796 66H10.6796C9.57957 66 8.67957 66.9 8.67957 68V84C8.67957 85.1 9.57957 86 10.6796 86H22.6796C23.7796 86 24.6796 85.1 24.6796 84V72L18.6796 66ZM16.6796 78C17.7796 78 18.6796 77.1 18.6796 76C18.6796 74.9 17.7796 74 16.6796 74C15.5796 74 14.6796 74.9 14.6796 76C14.6796 77.1 15.5796 78 16.6796 78ZM20.6796 81.43C20.6796 80.62 20.1996 79.9 19.4596 79.58C18.6096 79.21 17.6696 79 16.6796 79C15.6896 79 14.7496 79.21 13.8996 79.58C13.1596 79.9 12.6796 80.62 12.6796 81.43V82H20.6796V81.43Z"
          fill="#707070"
        />
      </g>
      <defs>
        <clipPath id="clip0_291_312">
          <rect width="132" height="110.858" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default NoRepresentative;
